import { render, staticRenderFns } from "./MainCard.vue?vue&type=template&id=345fde00&scoped=true"
import script from "./MainCard.vue?vue&type=script&lang=ts"
export * from "./MainCard.vue?vue&type=script&lang=ts"
import style0 from "./MainCard.vue?vue&type=style&index=0&id=345fde00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345fde00",
  null
  
)

export default component.exports